<template>
    <div>
        <div class="card mb-4">
            <div class="card-header">
                <div class="row">
                    <div class="col-6">
                        <h3 class="pull-left">
                            <strong>{{ trans.get('checkout.comments_or_requests') }}</strong>
                        </h3>
                    </div>
                    <div class="col-6">
                        <div class="text-right">
                            <i>
                            </i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row margin-top-30">
                    <div class="col-12 margin-bottom-20">
                        <label for="comments" class="comments">
                            {{ trans.get('checkout.comment_to_booking') }}
                        </label>
                        <div class="form__controls form__controls--default">
                            <textarea :disabled="loading" name="comments" id="comments" v-model="comments" class="form-control"></textarea>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="">
            <div class="col-md-12 col-12">
                <table border="0" width="90%" id="terms" class="text-left">
                    <tbody>
                    <tr>
                        <td>
                            <input :disabled="loading" required="" type="checkbox" v-model="terms" value="1" class="chbox" id="accept_terms">
                            <label id="terms_check" for="accept_terms">
                                {{ trans.get('checkout.i_have_read') }}
                                <a data-toggle="modal" data-target="#site-terms" style="cursor:pointer;">
                            <span style="text-decoration: underline !important;">
                                {{ trans.get('checkout.terms_conditions') }}
                            </span>
                                </a>{{ trans.get('checkout.and_accept_to_be_bound') }}
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input :disabled="loading" required="" type="checkbox" v-model="legal" value="1" class="chbox" id="accept_legal">
                            <label id="legal_check" for="accept_legal">
                                {{ trans.get('checkout.i_have_read') }}
                                <a data-toggle="modal" data-target="#site-privacy" style="cursor:pointer;">
                                    <span style="text-decoration: underline !important;">{{ trans.get('checkout.product_legal_terms') }}</span>
                                </a> {{ trans.get('checkout.and_accept_to_be_bound') }}
                            </label>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>

    import {mapFields} from "vuex-map-fields";

    export default {
        name    : 'terms',
        props   : {},
        data() {
            return {
                terms       : false,
                legal       : false,
                comment       : '',
                invoice_number: null,
            };
        },
        methods : {
        },
        computed: {
            ...mapFields([
                'order',
                'errors',
                'invoices',
                'loading',
                'order.comments',
            ]),
            isValid() {
                return this.terms && this.legal;
            },
        },
        mounted() {
        }
    }
</script>
